(function ($) {
    $(document).ready(function () {
        $(".comparison-table").each(function () {
            $('.comparison-table .table-grid td.three[data-tab="500"]').show();
            $(this).find('.comparison-table-item-head.three h3').on("click", function () {
                $(this).toggleClass("active");
            });
            $(this).find('.comparison-table-item-head.three ul li').on("click", function () {
                var text = $(this).text(), dataID = $(this).attr("data-tab");
                $('.comparison-table .table-grid td.three').hide();
                $(this).parent().parent().parent().find('h3.three').removeClass('active').text(text);
                $(this).parent().parent().parent().parent().parent().find('td[data-tab="' + dataID + '"]').show();
            });
        })
        $('.comparison-table .container').prepend('<div class="title"><h4>Compare with Competitors</h4></div>');
        $('.comparison-table .table-grid tr:first-child').append('<th class="comparison-table-item-head four"><h3>Other</h3></th>');
    });
})(jQuery);